module.exports = __webpack_public_path__ + "static/media/logo-slaek.e3ea4dcf.png";